import { RelayServerTransport } from '~/modules/remote-mic/network/server/transport/relay-server-transport';
import isE2E from '~/modules/utils/is-e2-e';

/**
 * This project's own relay (`partykit/mic-relay.ts`), rather than the shared one the game used
 * before it. What it buys: the room is held open for a minute after the game's socket drops, so a
 * hiccup on the game's network no longer throws every phone in the room out and makes them all
 * re-join. Empty until a deployment is pointed at - see the readme.
 *
 * E2E runs against the party server Playwright already starts on 1999.
 */
export const MIC_RELAY_SERVER: string = isE2E() ? 'ws://localhost:1999' : import.meta.env.VITE_APP_MIC_RELAY_URL;

export const hasMicRelay = () => !!MIC_RELAY_SERVER;

export class MicRelayServerTransport extends RelayServerTransport {
  public readonly name = 'MicRelay';

  protected getUrl = (roomId: string) => `${MIC_RELAY_SERVER}/parties/mic/${roomId}`;
}
